<template>
  <v-app>
    <v-app-bar
      v-if="!$vuetify.breakpoint.lg && !$vuetify.breakpoint.xl"
      color="deep-purple"
      dark
      app
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
    </v-app-bar>

    <v-navigation-drawer v-if="$store.state.TOKEN" v-model="drawer" app>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title">Arx Minerals</v-list-item-title>
          <v-list-item-subtitle>Административная панель</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider />

      <v-list dense nav>
        <v-list-item
          v-for="item in items"
          :key="item.title"
          link
          :to="item.route"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-main>
      <v-container fluid>
        <router-view />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data: () => ({
    login: true,
    drawer: false
  }),
  computed: {
    items() {
      return [
        {
          title: "Главная: слайдер",
          icon: "mdi-image-filter-hdr",
          route: "/admin/slider"
        },
        {
          title: "Главная: текст",
          icon: "mdi-image-filter-hdr",
          route: "/admin/main"
        },
        {
          title: "О компании",
          icon: "mdi-information-variant",
          route: "/admin/about"
        },
        {
          title: "О компании: Месторождение",
          icon: "mdi-information-variant",
          route: "/admin/about-list"
        },
        {
          title: "Миссия",
          icon: "mdi-flag-triangle",
          route: "/admin/mission"
        },
        {
          title: "Карьера",
          icon: "mdi-handshake-outline",
          route: "/admin/career"
        },
        {
          title: "Новости",
          icon: "mdi-newspaper-variant-outline",
          route: "/admin/news"
        },
      ];
    }
  },
  created() {
    this.$store.commit("setToken");
  },
  mounted() {
    if (document.querySelector("body").offsetWidth > 1200) {
      this.drawer = true;
    }
  }
};
</script>
<style lang="scss">
.v-main__wrap {
  background: #f1eee8;
}
</style>